import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const flagContabilidadFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagContabilidad'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagContabilidad' label='Uso de contabilidad' />
      )}
    </Field>
  )
}

export default React.memo(flagContabilidadFormGroup)
